import { render, staticRenderFns } from "./shareA.vue?vue&type=template&id=0e6bddd0&scoped=true&"
import script from "./shareA.vue?vue&type=script&lang=js&"
export * from "./shareA.vue?vue&type=script&lang=js&"
import style0 from "./shareA.vue?vue&type=style&index=0&id=0e6bddd0&scoped=true&lang=scss&"
import style1 from "./shareA.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e6bddd0",
  null
  
)

export default component.exports